import { c as _c } from "react/compiler-runtime";
import { copyTextToClipboard, useTranslation as useUiTranslation } from '@systemeio/ui';
import React from 'react';
import { LinkIcon } from '@systemeio/ui/icons';
interface FormAffiliateLinkProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const FormAffiliateLink = t0 => {
  const $ = _c(11);
  const {
    value
  } = t0;
  const {
    t: tUi
  } = useUiTranslation();
  let t1;
  if ($[0] !== value) {
    t1 = <input className="text-text-primary main-transition-colors border-text-secondary/30 focus:border-brand-primary placeholder:text-text-tertiary/70 disabled:bg-background-secondary w-full rounded-l-lg border px-4 py-2.5 focus:outline-hidden" disabled={true} type="text" value={value} spellCheck={false} />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tUi || $[3] !== value) {
    t2 = e => {
      e.preventDefault();
      copyTextToClipboard(value as string, tUi);
    };
    $[2] = tUi;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LinkIcon className="fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <button onClick={t2} className="bg-brand-primary hover:bg-brand-primary-hover ring-brand-primary flex items-center justify-center rounded-r-lg px-2 py-2.5 ring-offset-1 focus:outline-hidden focus-visible:ring-2 sm:px-4">{t3}</button>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <label className="flex flex-col gap-1 text-xs font-medium sm:text-sm"><div className="flex w-full">{t1}{t4}</div></label>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default FormAffiliateLink;